module.exports = __webpack_public_path__ + "static/media/heavy_pound01.c576c8bd.jpg";